
import { defineComponent, h, PropType, reactive, ref } from "vue";
import { DialogGenre } from "@/interfaces/common.interface";
import { tableConfig, shoninCommentHojoInfo, VIEW_NAME } from "./config";
import useDialog from "@/hooks/useDialog";
import Dialog from "./Dialog.vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { ComfirmMsg, InfoMsg } from "@/constants/message.constant";
import {
  deleteShoninCommentHojo,
  getShoninCommentHojoList,
} from "@/api/shinsei.api";
import { useChangeSeqList } from "./useChangeSeqList";

// テーブルの各行表示内容

export default defineComponent({
  name: "shoninComment",
  components: {
    Dialog,
  },
  props: {
    isDialogMode: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  emits: ["select"],
  setup() {
    const table = reactive({
      list: [] as shoninCommentHojoInfo[],
      total: 0,
      loading: true,
    });
    const defaultExpandAll = ref(false);
    const isEditSeqMode = ref(false);

    //検索メイン処理
    const getList = async () => {
      table.loading = true;
      table.list.length = 0;
      const { data } = await getShoninCommentHojoList();
      const { listData, total } = data.result;
      table.total = total;
      for (let i = 0; i < listData.length; i++) {
        table.list.push({
          id: listData[i].id,
          seq: +listData[i].seq,
          bunruiNm: listData[i].bunrui.bunrui,
          shoninComment: listData[i].shonin_comment,
          oldSeq: +listData[i].seq,
          hasSeqEdited: false,
          hasSeqExisted: false,
        });
      }
      table.loading = false;
      isEditSeqMode.value = false;
    };

    //削除イベント
    const handleDelete = (row: shoninCommentHojoInfo) => {
      ElMessageBox({
        title: "確認",
        message: h("p", null, [
          h("p", { style: "color: #b87d11" }, "SEQ：" + row.seq),
          h("p", { style: "color: #b87d11" }, "分類：" + row.bunruiNm),
          h("span", null, ComfirmMsg.CFM_DELETE),
        ]),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "はい",
        cancelButtonText: "いいえ",
      })
        .then(async () => {
          //削除処理
          await deleteShoninCommentHojo(row.id);
          ElMessage({
            type: "success",
            message: InfoMsg.INFO_SHONIN_COMMENT_DELETED,
          });
          getList();
        })
        .catch((cancel) => {
          console.log(cancel);
        });
    };

    //ダイアログ利用
    const { dialogTitle, dialogOperation, openDialog } = useDialog(VIEW_NAME);
    const { handleResetAllSeq, handleRowSeqChanged, handleUpdateSeq } =
      useChangeSeqList(isEditSeqMode, getList, table.list);

    //初期表示時、一回検索
    getList();

    return {
      table,
      tableConfig,
      getList,
      DialogGenre,
      dialogTitle,
      dialogOperation,
      openDialog,
      defaultExpandAll,
      handleDelete,
      isEditSeqMode,
      handleResetAllSeq,
      handleUpdateSeq,
      handleRowSeqChanged,
    };
  },
});
